import {
  DarkModeOutlined,
  LightModeOutlined,
  MoreVert,
  PersonAddAltOutlined,
  SettingsOutlined,
} from '@mui/icons-material';
import { Menu, MenuItem } from '@mui/material';
import cx from 'classnames';
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import { type Ref, useImperativeHandle, useRef } from 'react';
import { useLocation } from 'wouter';
import { darkTheme, lightTheme } from '~/theme.css';
import { transitionDuration } from '~/utils/constants';
import { useTheme, useToggleTheme } from '~/utils/store';
import * as avatarStyles from '../AvatarMenu/AvatarMenu.css';
import * as styles from './Header.css';

export type HeaderMoreHandle = {
  getAnchorEl: () => HTMLButtonElement | null;
};

export const HeaderMore = ({
  onShareOpen,
  showUpgrade,
  ref,
}: {
  onShareOpen: () => void;
  showUpgrade?: boolean;
  ref?: Ref<HeaderMoreHandle>;
}) => {
  const menu = usePopupState({ variant: 'popover' });
  const theme = useTheme();
  const toggleTheme = useToggleTheme();
  const [, navigate] = useLocation();
  const buttonRef = useRef<HTMLButtonElement>(null);

  useImperativeHandle(ref, () => ({
    getAnchorEl: () => buttonRef.current,
  }));

  return (
    <div className={cx(styles.headerMore, showUpgrade && styles.headerMoreVisible)}>
      <button
        ref={buttonRef}
        type="button"
        className={styles.buttonCircular}
        {...bindTrigger(menu)}
        aria-label="More options"
      >
        <MoreVert style={{ fontSize: 22 }} />
      </button>
      <Menu
        {...bindMenu(menu)}
        elevation={6}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transitionDuration={transitionDuration}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        className={cx(avatarStyles.menu, {
          [darkTheme]: theme === 'dark',
          [lightTheme]: theme === 'light',
        })}
        slotProps={{
          paper: {
            style: {
              marginTop: 2,
            },
          },
        }}
      >
        <MenuItem
          className={avatarStyles.menuItem}
          focusVisibleClassName={avatarStyles.menuItemFocusVisible}
          onClick={() => {
            menu.close();
            onShareOpen();
          }}
        >
          <PersonAddAltOutlined style={{ fontSize: 20, marginRight: 12, color: '#8f8f8f' }} />
          Share
        </MenuItem>
        <MenuItem
          className={avatarStyles.menuItem}
          focusVisibleClassName={avatarStyles.menuItemFocusVisible}
          onClick={() => {
            toggleTheme();
            menu.close();
          }}
        >
          {theme === 'light' ? (
            <DarkModeOutlined style={{ fontSize: 20, marginRight: 12, color: '#8f8f8f' }} />
          ) : (
            <LightModeOutlined style={{ fontSize: 20, marginRight: 12, color: '#8f8f8f' }} />
          )}
          {theme === 'light' ? 'Dark theme' : 'Light theme'}
        </MenuItem>
        <MenuItem
          className={avatarStyles.menuItem}
          focusVisibleClassName={avatarStyles.menuItemFocusVisible}
          onClick={() => {
            menu.close();
            navigate('/app/settings');
          }}
        >
          <SettingsOutlined style={{ fontSize: 20, marginRight: 12, color: '#8f8f8f' }} />
          Settings
        </MenuItem>
      </Menu>
    </div>
  );
};
